'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pixi = require('pixi.js');

var _pixi2 = _interopRequireDefault(_pixi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Timer = (function (_PIXI$utils$EventEmit) {
  _inherits(Timer, _PIXI$utils$EventEmit);

  function Timer() {
    var time = arguments.length <= 0 || arguments[0] === undefined ? 1 : arguments[0];
    var manager = arguments[1];

    _classCallCheck(this, Timer);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Timer).call(this));

    _this.time = time;
    if (manager) _this.addTo(manager);

    _this.active = false;
    _this.isEnded = false;
    _this.isStarted = false;
    _this.expire = false;
    _this.delay = 0;
    _this.repeat = 0;
    _this.loop = false;

    _this._delayTime = 0;
    _this._elapsedTime = 0;
    _this._repeat = 0;
    return _this;
  }

  _createClass(Timer, [{
    key: 'addTo',
    value: function addTo(manager) {
      this.manager = manager;
      this.manager.addTimer(this);
      return this;
    }
  }, {
    key: 'remove',
    value: function remove() {
      if (!this.manager) return;
      this.manager.removeTimer(this);
      return this;
    }
  }, {
    key: 'start',
    value: function start() {
      this.active = true;
      return this;
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.active = false;
      this.emit('stop', this._elapsedTime);
      return this;
    }
  }, {
    key: 'reset',
    value: function reset() {
      this._elapsedTime = 0;
      this._repeat = 0;
      this._delayTime = 0;
      this.isStarted = false;
      this.isEnded = false;
      return this;
    }
  }, {
    key: 'update',
    value: function update(delta, deltaMS) {
      if (!this.active) return;
      if (this.delay > this._delayTime) {
        this._delayTime += deltaMS;
        return;
      }

      if (!this.isStarted) {
        this.isStarted = true;
        this.emit('start', this._elapsedTime);
      }

      if (this.time > this._elapsedTime) {
        var t = this._elapsedTime + deltaMS;
        var ended = t >= this.time;

        this._elapsedTime = ended ? this.time : t;
        this.emit('update', this._elapsedTime, delta);

        if (ended) {
          if (this.loop || this.repeat > this._repeat) {
            this._repeat++;
            this.emit('repeat', this._elapsedTime, this._repeat);
            this._elapsedTime = 0;
            return;
          }

          this.isEnded = true;
          this.active = false;
          this.emit('end', this._elapsedTime);
        }
      }
    }
  }]);

  return Timer;
})(_pixi2.default.utils.EventEmitter);

exports.default = Timer;


/*****************
 ** WEBPACK FOOTER
 ** ./src/Timer.js
 ** module id = 1
 ** module chunks = 0
 **/